import * as Yup from "yup";
import { TranslateFunction } from "../../../contexts/LocalizationContext";

export const nameMappingValidationSchema = (translate : TranslateFunction) => Yup.object().shape({
  id: Yup.string(),
  oldName: Yup.string().required(translate("validation.fieldRequired")),
  newName: Yup.string().required(translate("validation.fieldRequired"))
});
